import { init } from "./sdk";

/**
 * Bootstrap din script tag:
 * <script src="https://cdn.example.com/sdk.js"
 *         data-app-id="app_xxx" data-public-key="pk_xxx"></script>
 * Opțional data-api-base; implicit, originea de pe care s-a încărcat scriptul.
 */
const script = document.currentScript as HTMLScriptElement | null;
const appId = script?.dataset.appId;
const publicKey = script?.dataset.publicKey;
const apiBase =
  script?.dataset.apiBase ?? (script?.src ? new URL(script.src).origin : location.origin);
// data-demo="true" DOAR pe siturile noastre de demo: întrebările merg pe
// /v1/demo/ask cu cookie de sesiune (login), nu pe calea publică anonimă.
const demo = script?.dataset.demo === "true";
/**
 * `data-bottom-offset="72"` - px, ridică orb-chatul + stratul de prezență
 * deasupra unui element de chrome fix al paginii (bară/banner peste care
 * ansamblul altfel cade) - vezi `orbchat/index.ts`. Un `Number()` nevalid
 * (absent, text, gol) cade pe 0 - implicitul de azi, nicio ridicare. Clamp
 * 0-300: negativ n-are sens (ar coborî ansamblul SUB fereastră), iar un
 * merchant care greșește cu o zecimală n-are cum să trimită orbul în afara
 * ecranului. Întreg - `--aig-lift` e px CSS, nu are ce face cu zecimale.
 */
const rawBottomOffset = Number(script?.dataset.bottomOffset);
const bottomOffset = Number.isFinite(rawBottomOffset)
  ? Math.min(300, Math.max(0, Math.trunc(rawBottomOffset)))
  : 0;

// Gardă de dublu-boot. Greșeala tipică e snippetul lipit de două ori (header +
// footer, sau temă + plugin): două bundle-uri = două module separate, deci
// flag-ul TREBUIE să stea pe window, nu în scope de modul. Fără ea ies două
// widgeturi suprapuse, două /config, două /sync-ack și același sessionStorage
// (cheie = appId) scris de ambele instanțe.
// Blocăm și cazul cu app-id-uri diferite: o pagină = un widget, oricum ar fi.
const w = window as unknown as Record<string, unknown>;
const alreadyBooted = w.__AIG_BOOTED__ === true;
w.__AIG_BOOTED__ = true;

if (alreadyBooted) {
  // Mesaj în engleză: ajunge în consola sitului clientului (vezi CLAUDE.md).
  console.warn(
    "[ai-guidance] the widget script is included more than once on this page; ignoring the extra copy. Remove the duplicate <script> tag.",
  );
} else if (!appId || !publicKey) {
  console.error("[ai-guidance] missing data-app-id or data-public-key on the script tag");
} else {
  const start = () => void init({ appId, publicKey, apiBase, demo, bottomOffset });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
}
